import api from "./axios.service";
import { getQueryStringFromObject } from "./common.service";
const axios = api;

async function getLanguages(query = {}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/languages' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


async function insertLanguage(languageData) {
    try {
        let response = await axios.post('/languages', languageData);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export {
    getLanguages,
    insertLanguage
}
